













































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import CopyStep from '@/shared/components/Copywrite/CopyStep.vue';
import CopyCountdown from '@/shared/components/Copywrite/CopyCountdown.vue';

import Header from '@/shared/components/Layout/Header.vue';

import Footer from '@/shared/components/Layout/Footer.vue';

import { IInvoice, ICheckoutCartOffer } from '@/interfaces/Checkout';

import { Payment } from '@/classes/Checkout/Payment';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');
const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    Header,
    Footer,
    CopyStep,
  },
})
export default class CustomTemplate extends Vue {
  @Prop()
  private readonly isRenewal: boolean;

  private compiledTemplate: any = null;
  private compiledTemplateKey: number = 0;
  private observer: IntersectionObserver;
  private isIntersecting: boolean = false;

  @CustomerModule.Getter
  private readonly firstName: string;

  @CustomerModule.Getter
  private readonly isLogged: boolean;

  @CustomerModule.Action
  private readonly logout: Function;

  @CheckoutModule.Getter
  private readonly customTemplateGuid: string;

  @CheckoutModule.Getter
  private readonly rootOffer: ICheckoutCartOffer;

  @CheckoutModule.Getter
  private readonly rootOfferInvoice: IInvoice;

  @CheckoutModule.Getter
  private readonly rootOfferPayment: Payment;

  @CheckoutModule.Getter
  private readonly rootOfferRelated: ICheckoutCartOffer[];

  @CheckoutModule.Getter
  private readonly selectedOffer: ICheckoutCartOffer;

  @CheckoutModule.Getter
  private readonly selectedOfferInvoice: IInvoice;

  @CheckoutModule.Getter
  private readonly selectedOfferPayment: Payment;

  @CheckoutModule.State
  private readonly orderForm: any;

  @CheckoutModule.Mutation
  private readonly selectOffer: Function;

  private get ROOT_TITLE () {
    return this.rootOffer.display_name;
  }

  private get hasRelatedOffers () {
    return this.onlyRelatedOffers.length > 0;
  }

  private get onlyRelatedOffers () {
    return this.rootOfferRelated.filter((offer: ICheckoutCartOffer) => offer.id !== this.rootOffer.id);
  }

  private get fieldsToTemplate () {
    let relatedFields: any = [];
    [1, 2, 3].map((index: number) => {
      const offer: any = this.onlyRelatedOffers[index - 1]
        ? this.onlyRelatedOffers[index - 1]
        : {};

      const offerInvoice = offer.invoice && offer.invoice.paymentMethodInstallments;

      relatedFields[`REL_${index}_TITLE`] = offer.display_name;
      relatedFields[`REL_${index}_INSTALLMENTS_AMOUNT`] = this.$n(offerInvoice ? offerInvoice.amount : '', 'currency');
      relatedFields[`REL_${index}_INSTALLMENTS_NUMBER`] = offerInvoice ? offerInvoice.number : '';
      relatedFields[`REL_${index}_INTERVAL`] = this.$t(`App.interval.${offer.interval_type}`);
      relatedFields[`REL_${index}_INTERVAL_TYPE`] = this.$t(`App.calendar.${offer.interval_type}`);
      relatedFields[`REL_${index}_INTERVAL_COUNT`] = offer.interval_count;
      relatedFields[`REL_${index}_INTERVAL_TYPE_PLURAL`] = this.$t(`App.interval_plural.${offer.interval_type}`);
    });

    const rootOfferInstallments = this.rootOfferInvoice.paymentMethodInstallments;
    const selectedOfferInstallments = this.selectedOfferInvoice.paymentMethodInstallments;

    return {
      ROOT_TITLE: this.rootOffer.display_name,
      ROOT_INSTALLMENTS_AMOUNT: this.$n(rootOfferInstallments && rootOfferInstallments.amount, 'currency'),
      ROOT_INSTALLMENTS_NUMBER: rootOfferInstallments && rootOfferInstallments.number,
      ROOT_INTERVAL: this.$t(`App.interval.${this.rootOffer.interval_type}`),
      ROOT_INTERVAL_TYPE: this.$t(`App.calendar.${this.rootOffer.interval_type}`),
      ROOT_INTERVAL_COUNT: this.rootOffer.interval_count,
      ROOT_INTERVAL_TYPE_PLURAL: this.$t(`App.interval_plural.${this.rootOffer.interval_type}`),

      SEL_TITLE: this.selectedOffer.display_name,
      SEL_INSTALLMENTS_AMOUNT: this.$n(selectedOfferInstallments && selectedOfferInstallments.amount, 'currency'),
      SEL_INSTALLMENTS_NUMBER: selectedOfferInstallments && selectedOfferInstallments.number,
      SEL_INTERVAL: this.$t(`App.interval.${this.selectedOffer.interval_type}`),
      SEL_INTERVAL_TYPE: this.$t(`App.calendar.${this.selectedOffer.interval_type}`),
      SEL_INTERVAL_COUNT: this.selectedOffer.interval_count,
      SEL_INTERVAL_TYPE_PLURAL: this.$t(`App.interval_plural.${this.rootOffer.interval_type}`),

      ...relatedFields,

      CUSTOMER_NAME: this.firstName,
    };
  }

  private get showSteps(): boolean {
    if (this.$vuetify.breakpoint.smAndDown) {
      return this.isLogged;
    }

    return true;
  }

  @Watch('fieldsToTemplate')
  onFieldsTemplateChange () {
    this.compiledTemplateKey += 1;
  }

  private addListenerToLogout (): void {
    const $logoutButton: HTMLElement|null = document.querySelector('.exit');

    $logoutButton && $logoutButton.addEventListener('click', () => this.logout());
  }

  private toggleCustomerFromHeader (status: boolean): void {
    const $customerHeader: HTMLElement|null = document.querySelector('.header-copy__customer');

    if ($customerHeader) {
      $customerHeader.style.display = status
        ? 'block'
        : 'none';
    }
  }

  private appendCSSCode (style: string) {
    let $styleTag = document.createElement('style');

    const scopedCSS = style.replace(/([^\r\n,{}]+)(,(?=[^}]*{)|\s*{)/g, (stylesheet: string) => {
      return stylesheet.includes('.')
        ? `.customTemplate .customTemplate__template ${stylesheet}`
        : stylesheet;
    });

    $styleTag.innerText = scopedCSS;

    document.head.appendChild($styleTag);
  }

  private appendScript (script: string) {
    const $script = document.createElement('script');

    $script.src = script;

    document.body.appendChild($script);
  }

  private get isMobile (): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get ABOrderForm() {
    return this.$route.query.of === '1';
  }

  private get showButton(): boolean {
    return this.ABOrderForm && this.isMobile ? true : false;
  }

  private handleIntersect(entry: IntersectionObserverEntry) {
    const isIntersecting = entry.isIntersecting;
    return isIntersecting ? this.isIntersecting = true : this.isIntersecting = false;
  }

  private async mounted () {
    try {
      let template = this.orderForm.template;

      let c = 0;
      template = template.replace(/class="copy-choice(?![\w\d])/g, (choice: string) => {
        const choiceOffer = this.rootOfferRelated[c];
        c++;

        if (!choiceOffer) {
          return `${choice} d-none `;
        }

        return `v-if="canShowRelated(${c})" @click="selectOffer(${choiceOffer.id})" :class="{ 'is-active': ${choiceOffer && choiceOffer.id} === this.selectedOffer.id }" ${choice}`;
      });

      template = template.replace(/class="copy-step(?![\w\d])/g, (choice: string) => {
        return `v-if="showSteps" ${choice}`;
      });

      template = template.replace(/{{ COUNTDOWN_15 }}/g, (countdown: any) => {
        const countdownNumbers = countdown.match(/[0-9]/g);
        const countdownTime = countdownNumbers && countdownNumbers.join('');

        return `
          <div class="countdown__wrapper">
            <h4 class="--uppercase --primary-text --centered pt-1 mb-5" v-if="isCountdownFinished">
              SUA VAGA AINDA ESTÁ DISPONÍVEL.
              <br> FINALIZE O CADASTRO AGORA MESMO!
            </h4>
            <h3 class="--centered mb-5" v-else>
              Esta oferta especial vai expirar em:
              <span class="--primary-text font-weight-bold">
                <CopyCountdown ref="countdown" :time="${countdownTime}" @onFinish="isCountdownFinished = true"/>
              </span>
            </h3>
          </div>
        `;
      });

      template = template.replace(/images\//g, () => {
        return `${process.env.VUE_APP_ORDERFORM_BASE_URL}${this.customTemplateGuid}/images/`;
      });

      Vue.component('rendered-template', {
        template,
        components: {
          CopyCountdown,
        },
        data: () => ({
          ...this.fieldsToTemplate,
          isCountdownFinished: false,
        }),
        watch: {
          'this.isLogged': {
            handler (status: boolean) {
              this.toggleCustomerFromHeader(status);
            },
          },
        },
        methods: {
          selectOffer: this.selectOffer,
          addListenerToLogout: this.addListenerToLogout,
          toggleCustomerFromHeader: this.toggleCustomerFromHeader,
          canShowRelated (c: number) {
            return this.relatedOffers[c - 1];
          }
        },
        computed: {
          isLogged: () => this.isLogged,
          selectedOffer: () => this.selectedOffer,
          showSteps: () => this.showSteps,
          relatedOffers: () => this.rootOfferRelated,
        },
        mounted () {
          this.addListenerToLogout();
          this.toggleCustomerFromHeader(this.isLogged);
        },
      });

      this.compiledTemplate = Vue.compile('<rendered-template/>');

      this.orderForm.styles.forEach(this.appendCSSCode);
      this.orderForm.scripts.forEach(this.appendScript);

      const customTemplateId = document.querySelector('#customTemplate');

      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          this.handleIntersect(entry);
        });
      });

      this.observer.observe(customTemplateId as HTMLElement);
    } catch (error) {
      console.error(error);
    }
  }
}
